import produce from 'immer';

import {
  NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_ERROR,
  NOTIFICATIONS_INFO,
  NOTIFICATION_INIT,
  ALL_NOTIFICATIONS,
  ALL_NOTIFICATIONS_SUCCESS,
  ALL_NOTIFICATIONS_ERROR,
} from './constants';


export interface newsState {
  success: boolean;
  error: boolean;
  info: boolean;
  warning : boolean;
  message: string;
  key: number,
  notifications: {
    loader: boolean,
    error: any,
    data: [],
    page: number;
    currentPage: number;
    pageCount: number;
  }
}

export const initialState: newsState = {
  success: false,
  error: false,
  info: false,
  warning : false,
  message: '',
  key: 0,
  notifications: {
    loader: false,
    error: null,
    data: [],
    page: 1,
    currentPage: 1,
    pageCount: 1,
  }
};

/* eslint-disable default-case, no-param-reassign */
const notificationsReducer = (state = initialState, action: any) =>

  produce(state, draft => {
    switch (action.type) {
      case NOTIFICATION_INIT:
        draft.message = '';
        draft.success = false;
        break;
      case NOTIFICATIONS_SUCCESS:   
        draft.message = action.message;
        draft.error = false;
        draft.success = true;
        draft.key = Math.random();
        break;
      case NOTIFICATIONS_ERROR:
        draft.message = action.message;
        draft.error = true;
        draft.success = false;
        draft.key = Math.random();
        break;
      case NOTIFICATIONS_INFO:
        draft.message = action.message;
        draft.info = true;
        break;  
      case ALL_NOTIFICATIONS:
        draft.notifications.loader = true;
        break;
      case ALL_NOTIFICATIONS_SUCCESS:
        draft.notifications.loader = false;
        draft.notifications.currentPage = action?.response?.data?.meta?.current_page || 1;
        draft.notifications.pageCount = action?.response?.data?.meta?.last_page || 1;
        draft.notifications.data = action.response.data.data;
        break;
      case ALL_NOTIFICATIONS_ERROR:
        draft.notifications.loader = false;
        draft.notifications.error =  action.error;
        break;    
    }
  });

export default notificationsReducer;
